import { render, staticRenderFns } from "./school-cooperation.vue?vue&type=template&id=53402e1a&scoped=true"
import script from "./school-cooperation.vue?vue&type=script&lang=js"
export * from "./school-cooperation.vue?vue&type=script&lang=js"
import style0 from "./school-cooperation.vue?vue&type=style&index=0&id=53402e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53402e1a",
  null
  
)

export default component.exports